module.exports = __webpack_public_path__ + "img/imaps_logo.55022617.png";